import { Label } from "office-ui-fabric-react";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ErrorMsg from "./ErrorMsg";
import { FieldContainer } from "./FieldContainer";
import { Controller } from "react-hook-form";
import Skeleton from "react-loading-skeleton";
import { useAppStoreState } from "store/AppStore";
import { useTheme } from "@fluentui/react";
import { Body1Strong, Select } from "@fluentui/react-components";
import { toInteger } from "lodash";

type Props = {
  form: any;
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  taxonomyKey: string;
  value?: any;
  visible?: boolean;
  isLoading: boolean;
  onBlur?: (e: any) => void;
};

export const TaxonomyField = ({
  name,
  label,
  required = false,
  disabled = false,
  taxonomyKey,
  form,
  visible,
  isLoading,
  onBlur = null,
}: Props) => {
  const {
    control,
    formState: { defaultValues, errors },
  } = form;

  const { t } = useTranslation();
  const { taxonomy } = useAppStoreState();
  const theme = useTheme();

  const options = useMemo(() => {
    if (!taxonomy || !taxonomy[taxonomyKey]) return [];
    const options = taxonomy[taxonomyKey]?.items.map((tax) => {
      return {
        value: tax.id,
        label: t(tax.code),
      };
    });

    return options;
  }, [t, taxonomy, taxonomyKey]);

  if (!visible) return null;
  return (
    <FieldContainer isTooltipHidden={false} tooltipText={label}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          return (
            <>
              {disabled ? (
                <Body1Strong
                  style={{
                    marginLeft: "15px",
                    color: isLoading ? "#888888" : null,
                  }}
                >
                  {options.find((el) => el.value === field.value)?.label}
                  <input
                    type="hidden"
                    name={name}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value)}
                  />
                </Body1Strong>
              ) : (
                <Select
                  required={required}
                  disabled={disabled || isLoading}
                  id={name}
                  name={field.name}
                  onBlur={(e) => {
                    field.onBlur();
                    onBlur && onBlur(e);
                  }}
                  onChange={(e, data) => {
                    field.onChange(data.value ? toInteger(data.value) : null);
                  }}
                  value={field.value || ""}
                  title={t("ehm.taxonomy.selectTitle.label")}

                  // placeholder={
                  //   disabled ? "" : t("greco.form.selectPlaceholder")
                  // }
                  // noOptionsMessage={() => t("greco.noResults")}
                  // isDisabled={disabled}
                  // isClearable
                  // inputId={name + "-input"}
                  // defaultValue={defaultValues[name]}
                >
                  {required ? <option key={"none"} value={""}></option> : null}
                  {options.map((tax) => (
                    <option key={tax.value} value={tax.value}>
                      {t(tax.label)}
                    </option>
                  ))}
                </Select>
              )}
              {errors && errors[name] ? (
                <ErrorMsg id={name + "_error"}>{errors[name].message}</ErrorMsg>
              ) : null}
            </>
          );
        }}
      />
    </FieldContainer>
  );
};

export default TaxonomyField;
